'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('../../transport/transport.js');

class Lottery {
  createBet(params) {
    return transport.transport.request("lottery/createBet", params);
  }
  bulkBuying(params) {
    return transport.transport.request("lottery/bulkBuying", params);
  }
  getOpenDraws(params) {
    return transport.transport.request("lottery/getOpenDraws", params);
  }
  getPreviousDraws(params) {
    return transport.transport.request("lottery/getPreviousDraws", params);
  }
  getProviders() {
    return transport.transport.request("lottery/getProviders");
  }
  getUserBets(params) {
    return transport.transport.request("lottery/getUserBets", params);
  }
  getUserBetResults(params) {
    return transport.transport.request("lottery/getUserBetResults", params);
  }
  getPayoutTable(params) {
    return transport.transport.request("lottery/getPayoutTable", params);
  }
  getWinningNumbersForDraw(params) {
    return transport.transport.request("lottery/getWinningNumbersForDraw", params);
  }
  get(params) {
    return transport.transport.request("lottery/get", params);
  }
  getAll(params) {
    return transport.transport.request("lottery/getAll", params);
  }
  subscribe(params) {
    return transport.transport.request("lottery/subscribe", params);
  }
  unsubscribe(params) {
    return transport.transport.request("lottery/unsubscribe", params);
  }
}

exports.Lottery = Lottery;
